import { useEffect, useRef, useState } from "react";
import chevron from "./assets/chevron.svg";
import check from "./assets/check.svg";
import "./stepper-dropdown.scss";

interface StepperDropdownProps {
  steps: Array<{ title: string }>;
  current: number;
  size?: number;
}

const StepperDropdown = (props: StepperDropdownProps) => {
  const { steps, current, size = 16 } = props;
  const [open, setOpen] = useState(false);
  const componentName = "stepper-dropdown";

  const container = useRef<HTMLDivElement>();

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    container.current.style.fontSize = size + "px";
  }, [size]);

  if (!steps[0].title) {
    console.warn("Please add steps.");
    return <></>;
  }

  return (
    <div ref={container} className={componentName} onClick={handleClick}>
      <div className={componentName + "__box" + (open ? " open" : "")}>
        {steps.map((step, idx) => {
          return (
            <div
              key={idx}
              className={`${componentName}__element ${
                idx < current ? componentName + "__element--completed" : ""
              } ${idx === current ? componentName + "__element--active" : ""}`}
            >
              <span
                className={
                  componentName +
                  "__icon " +
                  (idx <= current ? componentName + "__icon--active" : "")
                }
              >
                <img src={check} alt="Check" />
              </span>
              <span
                className={
                  componentName +
                  "__text " +
                  (idx <= current ? componentName + "__text--active" : "")
                }
              >
                {idx + 1} | {step.title}
              </span>
            </div>
          );
        })}
        <span className={componentName + "__chevron"}>
          <img src={chevron} alt="Desplegar" />
        </span>
      </div>
    </div>
  );
};

export default StepperDropdown;
